import React from 'react';

const TechStackPartners = () => {
  const techStack = ['React', 'Node.js', 'Python', 'Vue.js', 'Angular', 'TypeScript', 'AWS', 'Google Cloud', 'Docker', 'Kubernetes'];
  const partners = ['AWS Partner', 'Google Cloud Partner', 'MongoDB Atlas', 'Firebase', 'Stripe', 'Twilio'];

  const industries = [
    { name: 'E-Commerce', icon: '🛍️', description: 'Scalable shopping platforms with AI recommendations' },
    { name: 'Healthcare', icon: '⚕️', description: 'HIPAA-compliant telemedicine and patient management' },
    { name: 'FinTech', icon: '💰', description: 'Real-time financial dashboards and trading platforms' },
    { name: 'EdTech', icon: '📚', description: 'Interactive learning platforms with video streaming' },
    { name: 'Real Estate', icon: '🏠', description: 'Virtual tours and property management systems' },
    { name: 'Food & Delivery', icon: '🍕', description: 'On-demand delivery with real-time tracking' }
  ];

  return (
    <>
      <section id="tech-stack">
        <div className="section-header">
          <h2 className="section-title">Technology Stack</h2>
          <p className="section-subtitle">We master the latest and most reliable technologies</p>
        </div>
        <div className="tech-stack-grid">
          {techStack.map((tech, index) => (
            <div className="tech-item fade-in" key={index} style={{animationDelay: `${(index % 5) * 0.1}s`}}>
              <div className="tech-icon">💻</div>
              <p>{tech}</p>
            </div>
          ))}
        </div>
      </section>

      <section id="partners">
        <div className="section-header">
          <h2 className="section-title">Trusted Partnerships</h2>
          <p className="section-subtitle">Certified partners with industry leaders</p>
        </div>
        <div className="partners-grid">
          {partners.map((partner, index) => (
            <div className="partner-badge fade-in" key={index} style={{animationDelay: `${(index % 3) * 0.1}s`}}>
              {partner}
            </div>
          ))}
        </div>
      </section>

      <section id="industries">
        <div className="section-header">
          <h2 className="section-title">Industries We Serve</h2>
          <p className="section-subtitle">Expertise across diverse sectors and domains</p>
        </div>
        <div className="industries-grid">
          {industries.map((industry, index) => (
            <div className="industry-card fade-in" key={index} style={{animationDelay: `${(index % 3) * 0.1}s`}}>
              <div className="industry-icon">{industry.icon}</div>
              <h4>{industry.name}</h4>
              <p>{industry.description}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default TechStackPartners;
